// bionicText.js
// Utility function for bionic reading effect (bolds first half of each word)
import React from 'react';

export function bionicText(text) {
  return text.split(' ').map((word, index) => {
    if (!word) return ' ';
    const mid = Math.ceil(word.length / 2);
    return (
      <>
        <b key={index * Math.random() + '-bionic'}>{word.slice(0, mid)}</b>{word.slice(mid)}{' '}
      </>
    );
  });
}
